import * as React from "react";
import ContactoContainer from "../conteiners/contacto-container";

export default function ContactoPage() {
  return <ContactoContainer></ContactoContainer>;
}
